import script from "./Careers.vue?vue&type=script&setup=true&lang=js"
export * from "./Careers.vue?vue&type=script&setup=true&lang=js"

import "./Careers.vue?vue&type=style&index=0&id=546184f7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-546184f7"]])

export default __exports__